import { render, staticRenderFns } from "./SkupTemaDetails.vue?vue&type=template&id=97957fb4&scoped=true&"
import script from "./SkupTemaDetails.vue?vue&type=script&lang=js&"
export * from "./SkupTemaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97957fb4",
  null
  
)

export default component.exports